module.exports = __webpack_public_path__ + "img/China-4-hover.4222c961.jpg";